import React, { useEffect, useRef, useState } from 'react';
import AccountMainLayout from '../Layout/AccountMainLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  STRIPE_PUBLISHABLE_KEY,
  billingOverview,
  paymentMethodApi,
} from '../utils/endpoint';
import { deleteApi, getApi, putApi } from '../utils/api';
import Cookies from 'js-cookie';
import { generatePrice } from '../utils/helpers';
import { ThreeDots } from 'react-loader-spinner';
import ErrorBanner from './ErrorBanner';
import { useSelector } from 'react-redux';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PaymentForm from '../components/PaymentForm';
import PropTypes from 'prop-types';

const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

const SectionLoader = ({ message = 'Loading...' }) => {
  return (
    <div className="card bills-card bills-card-account mb-4">
      <div className="d-flex flex-column align-items-center justify-content-center py-4">
        <ThreeDots
          height="35"
          width="35"
          radius="9"
          color="#aeaeae"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          wrapperClassName=""
          visible={true}
        />
        <p className="mb-0 mt-2">{message}</p>
      </div>
    </div>
  );
};

const SectionMessage = ({ message, isError = false }) => {
  return (
    <>
      <div className="card bills-card  mb-4">
        <div className={`text-center py-4 ${isError ? 'text-danger' : ''}`}>
          {message}
        </div>
      </div>
    </>
  );
};

SectionLoader.propTypes = {
  message: PropTypes.string,
};

SectionMessage.propTypes = {
  message: PropTypes.string.isRequired,
  isError: PropTypes.bool,
};

const AccountBilling = () => {
  const [show, setShow] = useState(false);
  const [invoice, setInvoice] = useState([]);
  const [upcomingInvoice, setUpcomingInvoice] = useState(null);
  const [billingPlan, setBillingPlan] = useState(null);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [billingLoading, setBillingLoading] = useState(true);
  const [paymentMethodLoading, setPaymentMethodLoading] = useState(true);
  const [billingError, setBillingError] = useState('');
  const [paymentMethodError, setPaymentMethodError] = useState('');
  const [isDelete, setIsDelete] = useState(false);
  const [isPrimary, setIsPrimary] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState();
  const [selectedDeleteId, setSelectedDeleteId] = useState();
  const [showError, setShowError] = useState(false);
  const [showErrorDetail, setShowErrorDetail] = useState({
    isError: true,
    message: '',
  });
  const [isError, setIsError] = useState('');
  const detailsTableRef = useRef(null);

  const { personalDetail } = useSelector((state) => state.signup);
  const navigate = useNavigate();
  const access_token = Cookies.get('userToken');
  const { state } = useLocation();
  const { dataState } = state || '';

  useEffect(() => {
    if (
      personalDetail?.subscriptions?.length === 0 &&
      Cookies.get('isSubscribed') === undefined
    ) {
      navigate('/plans');
    }
  }, []);

  useEffect(() => {
    setBillingLoading(true);
    setBillingError('');
    getApi(billingOverview, access_token)
      .then((res) => {
        if (res?.data?.success) {
          setBillingPlan(res?.data?.data?.plan || null);
          setInvoice(
            Array.isArray(res?.data?.data?.invoices)
              ? res.data.data.invoices
              : []
          );
          setUpcomingInvoice(res?.data?.data?.upcomingInvoice || null);
          return;
        }

        setBillingPlan(null);
        setInvoice([]);
        setUpcomingInvoice(null);
        setBillingError(
          res?.data?.message || 'Unable to load billing details.'
        );
      })
      .catch(() => {
        setBillingPlan(null);
        setInvoice([]);
        setUpcomingInvoice(null);
        setBillingError('Unable to load billing details. Please try again.');
      })
      .finally(() => {
        setBillingLoading(false);
      });

    fetchPaymentMethod();
  }, []);

  const fetchPaymentMethod = () => {
    setPaymentMethodLoading(true);
    setPaymentMethodError('');
    getApi(paymentMethodApi, access_token)
      .then((res) => {
        if (res?.data?.success) {
          setPaymentMethodList(res?.data.data);
          return;
        }

        setPaymentMethodList([]);
        setPaymentMethodError(
          res?.data?.message || 'Unable to load payment methods.'
        );
      })
      .catch(() => {
        setPaymentMethodList([]);
        setPaymentMethodError(
          'Unable to load payment methods. Please try again.'
        );
      })
      .finally(() => {
        setPaymentMethodLoading(false);
      });
  };

  // const handleTabAction = (currentTabId, nextTabId) => {
  //   const currentTabButton = document.querySelector(`#${currentTabId}-tab`);
  //   currentTabButton.classList.remove("active");

  //   const currentTabContent = document.querySelector(`#${currentTabId}`);
  //   currentTabContent.classList.remove("active");
  //   currentTabContent.classList.remove("show");

  //   const nextTabButton = document.querySelector(`#${nextTabId}-tab`);
  //   nextTabButton.classList.add("active");

  //   const nextTabContent = document.querySelector(`#${nextTabId}`);
  //   nextTabContent.classList.add("show", "active");
  //   window.scrollTo(0, 0);
  // };

  const handleClose = () => {
    setShowError(false);
    setShowErrorDetail({
      isError: true,
      message: '',
    });
  };

  // const handleUpdatePayment = (e) => {
  //   setShowErrorDetail({
  //     isError: false,
  //     message: 'We have sent you an email to update your payment method',
  //   });
  //   setShowError(true);
  //   setTimeout(() => {
  //     setShowError(false);
  //     setShowErrorDetail({
  //       isError: true,
  //       message: '',
  //     });
  //   }, 4000);
  // };

  const handleNavigate = () => {
    const tabEle = document.querySelectorAll('.nav-link');
    // Remove active class from tab list
    const activeElements = document.querySelectorAll('.active');
    activeElements.forEach((element) => {
      if (element?.classList?.length > 1) {
        element.classList.remove('active');
      }
    });

    // Add active class to Payment History tab
    tabEle.forEach((element) => {
      if (element.id === 'nav-profile-tab') {
        element.classList.add('active');
        const tabContent = document.getElementById('nav-profile');
        tabContent.classList.add('active', 'show');
      }
    });

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleBackToBillingOverview = () => {
    const tabEle = document.querySelectorAll('.nav-link');
    // Remove active class from tab list
    const activeElements = document.querySelectorAll('.active');
    activeElements.forEach((element) => {
      if (element?.classList?.length > 1) {
        element.classList.remove('active');
      }
    });

    // Add active class to Billing Overview tab
    tabEle.forEach((element) => {
      if (element.id === 'nav-home-tab') {
        element.classList.add('active');
        const tabContent = document.getElementById('nav-home');
        tabContent.classList.add('active', 'show');
      }
    });
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setIsDelete(true);
    setIsError();
    deleteApi(paymentMethodApi + '/' + selectedDeleteId, access_token)
      .then((res) => {
        if (res?.data?.success) {
          fetchPaymentMethod();
          setIsDelete(false);
          setSelectedDeleteId();
          const modalClose = document.getElementsByClassName('cancel-sure')[0];
          modalClose.click();
        }
      })
      .catch((err) => {
        setIsError(err?.response?.data?.message);
        setIsDelete(false);
      });
  };

  const handleDeleteConfirmation = (id) => {
    setSelectedDeleteId(id);
  };

  const handleCloseSure = () => {
    setSelectedDeleteId();
    setIsError();
  };

  const handleUpdateDefault = (e, id, index) => {
    e.preventDefault();
    setIsPrimary(true);
    setSelectedIndex(index);
    putApi(paymentMethodApi + '/' + id + '/default', {}, access_token)
      .then((res) => {
        if (res?.data?.success) {
          fetchPaymentMethod();
          setIsPrimary(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsPrimary(false);
      });
  };

  const handleToggleDetails = (e) => {
    e.preventDefault();

    setShow((previousShow) => {
      const nextShow = !previousShow;

      if (nextShow) {
        requestAnimationFrame(() => {
          detailsTableRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        });
      }

      return nextShow;
    });
  };

  useEffect(() => {
    if (dataState === 'paymentMethod') {
      const tabEle = document.querySelectorAll('.nav-link');
      // Remove active class from tab list
      const activeElements = document.querySelectorAll('.active');
      activeElements.forEach((element) => {
        if (element?.classList?.length > 1) {
          element.classList.remove('active');
        }
      });

      // Add active class to Payment History tab
      tabEle.forEach((element) => {
        if (element.id === 'nav-contact-tab') {
          element.classList.add('active');
          const tabContent = document.getElementById('nav-contact');
          tabContent.classList.add('active', 'show');
          console.log(dataState, element.id, 'paymentMethod ');
        }
      });
    }
  }, [paymentMethodList]);

  const cardBrandImages = {
    visa: '../images/cards/visa.svg',
    mastercard: '../images/cards/master-card.svg',
    amex: '../images/cards/amex.svg',
    discover: '../images/cards/discover.svg',
    circle: '../images/cards/circle.svg',
  };

  const hasUpcomingDues =
    !!upcomingInvoice && Number(upcomingInvoice?.total || 0) !== 0;
  const hasInvoiceHistory = Array.isArray(invoice) && invoice.length > 0;

  const activeTerm =
    upcomingInvoice && hasInvoiceHistory
      ? invoice[0]?.term?.find(
          (t) => Number(t.price) * 100 === Number(upcomingInvoice.total)
        ) || invoice[0]?.term?.[0]
      : null;

  const planName = billingPlan?.name || billingPlan?.plan?.name || '';
  const planFrequency = activeTerm?.price_frequency || '';
  const planCardValue =
    planName && planFrequency
      ? `${planName} - ${planFrequency}`
      : planName || planFrequency || 'Lifetime';
  const planCardDescription = activeTerm
    ? `Renews on ${upcomingInvoice.date}`
    : 'No recurring charges';
  const nextBillingValue = upcomingInvoice?.date || 'None';
  const nextBillingDescription = upcomingInvoice?.amount
    ? `Next payment of ${upcomingInvoice.amount}`
    : 'Lifetime plan paid in full';

  return (
    <>
      <AccountMainLayout>
        <div className="account-login pt-5">
          <div className="container-fluid">
            {showError && (
              <ErrorBanner error={showErrorDetail} handleClose={handleClose} />
            )}
            <div className="row">
              <div className="col-lg-8">
                <nav className="tabs-bills">
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button
                      className="nav-link active"
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="true"
                    >
                      Billing Overview
                    </button>
                    <button
                      className="nav-link d-none"
                      id="nav-profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-profile"
                      type="button"
                      role="tab"
                      aria-controls="nav-profile"
                      aria-selected="false"
                    >
                      Payment History
                    </button>
                    <button
                      className="nav-link"
                      id="nav-contact-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-contact"
                      type="button"
                      role="tab"
                      aria-controls="nav-contact"
                      aria-selected="false"
                    >
                      Payment Methods
                    </button>
                  </div>
                </nav>
                <div className="tab-content pane-bill" id="nav-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="nav-home"
                    role="tabpanel"
                    aria-labelledby="nav-home-tab"
                  >
                    <div className="history mt-4">
                      <h3 className="up-coming-bill">Upcoming Bills</h3>
                    </div>
                    {billingLoading ? (
                      <SectionLoader message="Loading upcoming bill..." />
                    ) : billingError ? (
                      <SectionMessage message={billingError} isError={true} />
                    ) : hasUpcomingDues ? (
                      <div className="card bills-card bills-card-account mb-4">
                        <table className="amount-card mobile-responsive">
                          <thead>
                            <tr>
                              <th>Due Date</th>
                              <th>Description</th>
                              <th>Amount Due</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td data-label="Due Date">
                                {upcomingInvoice?.date && upcomingInvoice?.date}
                              </td>

                              <td data-label="Description">
                                {upcomingInvoice?.product_name}
                              </td>
                              <td data-label="Amount Due">
                                {upcomingInvoice?.amount &&
                                  upcomingInvoice?.amount}
                              </td>
                              <td data-label="Status">
                                {upcomingInvoice?.status === 'draft'
                                  ? 'Upcoming'
                                  : ''}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <SectionMessage message="No upcoming payments." />
                    )}
                    {billingLoading ? (
                      <SectionLoader message="Loading plan details..." />
                    ) : (
                      <div className="plan-list">
                        <div className="row">
                          {/* Plan Card */}
                          <div className="col-md-4 mb-3">
                            <div className="billing-info-card">
                              <div className="card-label">PLAN</div>
                              <h3 className="card-value">{planCardValue}</h3>
                              <p className="card-description">
                                {planCardDescription}
                              </p>
                            </div>
                          </div>

                          {/* Next Billing Date Card */}
                          <div className="col-md-4 mb-3">
                            <div className="billing-info-card">
                              <div className="card-label">
                                NEXT BILLING DATE
                              </div>
                              <h3 className="card-value">{nextBillingValue}</h3>
                              <p className="card-description">
                                {nextBillingDescription}
                              </p>
                            </div>
                          </div>

                          {/* Estimated Savings Card */}
                          <div className="col-md-4 mb-3">
                            <div className="billing-info-card">
                              <div className="card-label">
                                EST. SAVINGS VS. WALK-IN
                              </div>
                              <h3 className="card-value card-value-highlight">
                                $214
                              </h3>
                              <p className="card-description">
                                Across 7 range sessions
                              </p>
                            </div>
                          </div>
                        </div>

                        {/* Membership Payoff Banner */}
                        <div className="membership-payoff-banner">
                          <div className="banner-content">
                            <h4 className="banner-title">
                              Your membership is paying off
                            </h4>
                            <p className="banner-description">
                              You&apos;ve saved an estimated{' '}
                              <span className="highlight-amount">$214</span> in
                              discounted range fees since joining. At this pace,
                              your lifetime membership recoups its cost well
                              within the year.
                            </p>
                          </div>
                          <div className="banner-savings">
                            <span className="savings-amount">$214</span>
                            <span className="savings-label">TOTAL SAVED</span>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="history">
                      <h3 className="up-coming-bill">
                        Payment History (Last 90 Days)
                      </h3>
                      <Link
                        className="link-text"
                        type="button"
                        onClick={handleNavigate}
                      >
                        View Full Payment History
                      </Link>
                    </div>
                    {billingLoading ? (
                      <SectionLoader message="Loading payment history..." />
                    ) : billingError ? (
                      <SectionMessage message={billingError} isError={true} />
                    ) : hasInvoiceHistory ? (
                      <div className="card bills-card bills-card-account mb-4">
                        <table className="amount-card mobile-responsive">
                          <thead>
                            <tr>
                              <th>Payment Date</th>
                              <th>Description</th>
                              <th>Amount</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {invoice?.map((item, index) => (
                              <tr key={index}>
                                <td data-label="Payment Date-">{item?.date}</td>
                                <td data-label="Description">
                                  {item?.product_name}
                                </td>
                                <td data-label="Amount">{item?.amount}</td>
                                <td data-label="Status">
                                  {item?.status.charAt(0).toUpperCase() +
                                    item?.status.slice(1)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <SectionMessage message="No transactions yet." />
                    )}
                    <div className="refer-friend">
                      <div className="referral-banner">
                        <div className="referral-content">
                          <h4 className="referral-heading">
                            Refer a Friend — Give $20, Get $20
                          </h4>
                          <p className="referral-description">
                            Share your code and you both receive $20 in range
                            credits when they join. No limit on referrals.
                          </p>
                        </div>
                        <div className="referral-code-section">
                          <div className="referral-code-box">
                            <span className="referral-code">CALIBER-LK42</span>
                          </div>
                          <button className="share-code-btn">Share Code</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="nav-profile"
                    role="tabpanel"
                    aria-labelledby="nav-profile-tab"
                  >
                    {billingLoading ? (
                      <SectionLoader message="Loading payment history..." />
                    ) : billingError ? (
                      <SectionMessage message={billingError} isError={true} />
                    ) : hasInvoiceHistory ? (
                      <>
                        <div className="history mt-4">
                          <h3 className="up-coming-bill">Payment History</h3>
                          <button className="back-button-set">
                            <Link
                              className="button-golden border-golden my-0"
                              to="#"
                              onClick={handleBackToBillingOverview}
                            >
                              Back
                            </Link>
                          </button>
                        </div>
                        <div className="card bills-card bills-card-account table-responsive">
                          <table className="amount-card  mobile-responsive">
                            <thead>
                              <tr>
                                <th>Date</th>
                                {/* <th>Description</th> */}
                                <th>Amount</th>
                                <th>Mode Of Payment</th>
                                <th>Card Description</th>
                                <th>Status</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {invoice?.map((item, index) => (
                                <tr key={index}>
                                  <td data-label="Date">{item?.date}</td>
                                  {/* <td data-label="Description">
                                    {item?.product_name}
                                  </td> */}
                                  <td data-label="Amount">{item?.amount}</td>
                                  <td data-label="Mode Of Payment">
                                    Credit Card
                                  </td>
                                  <td data-label="Card Description">
                                    <p
                                      style={{
                                        whiteSpace: 'wrap',
                                      }}
                                    >
                                      {' '}
                                      {item?.card_info?.brand
                                        .charAt(0)
                                        .toUpperCase() +
                                        item?.card_info?.brand.slice(1)}
                                      (****{item?.card_info?.last4}) - Expires:
                                      {' ' + item?.card_info?.exp_month}/
                                      {item?.card_info?.exp_year}
                                    </p>
                                  </td>
                                  <td data-label="Status">
                                    {item?.status.charAt(0).toUpperCase() +
                                      item?.status.slice(1)}
                                  </td>
                                  <td data-label="Action">
                                    <Link
                                      to="#"
                                      className="details-list2"
                                      onClick={handleToggleDetails}
                                    >
                                      {show ? 'Hide Details' : 'View Details'}
                                    </Link>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        {show ? (
                          <>
                            <div className="history mt-4">
                              <h3 className="up-coming-bill mb-0">
                                Plan History
                              </h3>
                            </div>
                            <div
                              className="card bills-card bills-card-account mb-4"
                              ref={detailsTableRef}
                            >
                              <table className="amount-card bills-card-account mobile-responsive">
                                <thead>
                                  <tr>
                                    <th>Plan</th>
                                    <th>Amount</th>
                                    <th>Term</th>
                                    <th>Order</th>
                                    <th>Tax</th>
                                    <th>Total</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {invoice?.map((item, index) => (
                                    <tr key={index}>
                                      <td data-label="Plan">
                                        {item?.product_name}
                                      </td>
                                      <td data-label="Amount">
                                        {item?.amount}
                                      </td>
                                      <td data-label="Term">
                                        {item?.term &&
                                          item?.term[0]?.price_frequency}
                                      </td>
                                      <td data-label="Order">{item?.number}</td>
                                      <td data-label="Tax">
                                        {item?.tax && generatePrice(item?.tax)}
                                      </td>
                                      <td data-label="Total">
                                        {item?.total &&
                                          generatePrice(item?.total / 100)}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </>
                        ) : null}
                      </>
                    ) : (
                      <SectionMessage message="No transactions yet." />
                    )}
                  </div>
                  <div
                    className="tab-pane fade mt-4"
                    id="nav-contact"
                    role="tabpanel"
                    aria-labelledby="nav-contact-tab"
                  >
                    {paymentMethodLoading ? (
                      <SectionLoader message="Loading payment methods..." />
                    ) : paymentMethodError ? (
                      <SectionMessage
                        message={paymentMethodError}
                        isError={true}
                      />
                    ) : paymentMethodList?.length > 0 ? (
                      <>
                        <Link
                          className="link-text m-0 d-block d-md-none text-end mt-4"
                          to="/payment-method-new"
                          // data-bs-toggle="modal"
                          // data-bs-target="#staticBackdrop-payment-update"
                        >
                          Add Payment Method
                        </Link>
                        <div className="history mt-4">
                          <h3 className="up-coming-bill">Payment Methods</h3>
                        </div>
                        <div className="card bills-card bills-card-account mb-4">
                          <table className="amount-card mobile-responsive">
                            <thead>
                              <tr>
                                <th>Type</th>
                                <th colSpan="9">Description</th>
                                <th style={{ textAlign: 'right' }}>
                                  {/* <Link
           onClick={handleUpdatePayment}
           className="button-golden size-font m-0"
           data-bs-toggle="modal"
           data-bs-target="#staticBackdrop-payment-update"
         >
           update payment method
         </Link> */}
                                  <Link
                                    className="link-text"
                                    // data-bs-toggle="modal"
                                    // data-bs-target="#staticBackdrop-payment-update"
                                    to="/payment-method-new"
                                  >
                                    Add Payment Method
                                  </Link>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {paymentMethodList?.map((item, index) => (
                                <tr key={index}>
                                  <td data-label="Type">
                                    {item?.card?.funding === 'credit'
                                      ? 'Credit '
                                      : 'Debit '}
                                    Card
                                  </td>
                                  <td
                                    data-label="Description"
                                    style={{
                                      whiteSpace: 'wrap',
                                    }}
                                  >
                                    <img
                                      className="me-2"
                                      src={cardBrandImages[item?.card?.brand]}
                                      alt={`${item?.card?.brand} Card `}
                                    />
                                    **** **** **** {item?.card?.last4}
                                  </td>
                                  <td colSpan="2">
                                    {item.is_default ? 'Primary' : 'Secondary'}
                                  </td>
                                  <td className="delete-payment">
                                    <button
                                      className={`button-golden border-golden delete-button-pd size-font my-0
                                    ${isDelete ? 'disabled-delete' : ''}
                                    `}
                                      data-bs-toggle="modal"
                                      data-bs-target="#staticBackdrop-confirmation"
                                      onClick={() =>
                                        handleDeleteConfirmation(item.id)
                                      }
                                    >
                                      Delete
                                    </button>
                                  </td>
                                  <td>
                                    {!item.is_default && (
                                      <button
                                        className={`details-list2`}
                                        onClick={(e) =>
                                          handleUpdateDefault(e, item.id, index)
                                        }
                                      >
                                        {isPrimary &&
                                        selectedIndex === index ? (
                                          <ThreeDots
                                            height="15"
                                            width="25"
                                            radius="10"
                                            color="#1A2A3F"
                                            ariaLabel="three-dots-loading"
                                            wrapperStyle={{}}
                                            wrapperClassName=""
                                            visible={true}
                                          />
                                        ) : (
                                          ' Set as primary'
                                        )}
                                      </button>
                                    )}
                                  </td>
                                  {/* <td className="d-none"></td> */}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </>
                    ) : (
                      <div className="method-found">
                        <p>
                          No Payment method found, Please add a new payment
                          method.
                        </p>
                        <Link
                          className="link-text"
                          // data-bs-toggle="modal"
                          // data-bs-target="#staticBackdrop-payment-update"
                          to="/payment-method-new"
                        >
                          Add Payment Method
                        </Link>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                {/* Partner Spotlight */}
                <div className="sidebar-card partner-spotlight">
                  <h6 className="sidebar-heading">PARTNER SPOTLIGHT</h6>
                  <div className="partner-content">
                    <div className="partner-title-row">
                      <div className="partner-logo-box">
                        <span className="partner-logo-text">USCCA</span>
                      </div>
                      <div className="partner-title-content">
                        <h5 className="partner-title">USCCA Partnership</h5>
                        <p>Self-defense coverage</p>
                      </div>
                    </div>
                    <p className="partner-description">
                      Caliber Card members save on USCCA membership-self-
                      defense liability, 24/7 response team, and training
                      access.
                    </p>
                    <button className="partner-btn">Learn More</button>
                  </div>
                </div>

                {/* Sponsored Section */}
                <div className="sidebar-card sponsored-section">
                  <h6 className="sidebar-heading">SPONSORED</h6>
                  <div className="sponsored-content">
                    <div className="sponsored-logo-box">
                      <h6 className="sidebar-heading">PARTNER OFFER</h6>
                      <span className="sponsored-logo-text">SIG SAUER</span>
                      <p className="sponsored-description">
                        The P365 - America&lsquo;s most-carried pistol. Explore
                        the full lineup at your member rate.
                      </p>
                      <button className="sponsored-btn">
                        View SIG Offers{' '}
                        <i
                          className="fa fa-long-arrow-right"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Membership Documents */}
                <div className="sidebar-card membership-docs">
                  <h6 className="sidebar-heading">Account</h6>
                  <ul className="docs-list">
                    <li>
                      <a href="#" className="doc-link">
                        <span className="doc-link-text">
                          Manage Payment Method
                        </span>
                        <svg
                          className="chevron-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M6 12L10 8L6 4"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="doc-link">
                        <span className="doc-link-text">Download Receipt</span>
                        <svg
                          className="chevron-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M6 12L10 8L6 4"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </a>
                    </li>
                    <li>
                      <a href="#" className="doc-link">
                        <span className="doc-link-text">Cancel Membership</span>
                        <svg
                          className="chevron-icon"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M6 12L10 8L6 4"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal fade"
            id="staticBackdrop-payment-update"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body d-flex">
                  <Elements stripe={stripePromise}>
                    <PaymentForm
                      // Heading="Add a new payment method"
                      ButtonFirst="Add"
                      fetchPaymentMethod={fetchPaymentMethod}
                    />
                  </Elements>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="staticBackdrop-confirmation"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body delete-text">
                <p>Are you sure you wish to delete this card detail?</p>
              </div>
              <div className="modal-footer cancel-button">
                <button
                  type="button"
                  className={`cancel ok` + (isDelete ? ' disabled-btn' : '')}
                  onClick={handleDelete}
                >
                  {isDelete ? (
                    <ThreeDots
                      height="30"
                      width="30"
                      radius="9"
                      color="#fff"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClassName=""
                      visible={true}
                    />
                  ) : (
                    'Yes'
                  )}
                </button>
                <button
                  type="button"
                  className="cancel cancel-sure"
                  data-bs-dismiss="modal"
                  onClick={handleCloseSure}
                >
                  No
                </button>
              </div>
              {isError && (
                <div className="mb-3 text-center text-danger">{isError}</div>
              )}
            </div>
          </div>
        </div>
      </AccountMainLayout>
    </>
  );
};

export default AccountBilling;
